import { logger } from '@/ui/utilities/instrumentation/logger'

type ImgixFit = 'crop' | 'clip' | 'fill' | 'max' | 'min' | 'scale'

type ImgixParams = {
	w?: number
	h?: number
	fit?: ImgixFit
	dpr?: number
	q?: number
	auto?: string
}

export function imgixUrl(baseUrl: string, params: ImgixParams = {}): string {
	if (!baseUrl) {
		return baseUrl
	}
	try {
		const url = new URL(baseUrl)
		for (const [key, value] of Object.entries(params)) {
			if (value !== undefined) {
				url.searchParams.set(key, String(value))
			}
		}
		if (!url.searchParams.has('auto')) {
			url.searchParams.set('auto', 'format,compress')
		}
		return url.toString()
	} catch (error) {
		logger.error(error, { data: { message: 'Failed to parse baseUrl for imgix URL', baseUrl } })
		return baseUrl
	}
}
